import { CALL_API } from '../middleware/api'

export const ADMIN_NOTIFICATIONS_REQUEST = 'ADMIN_NOTIFICATIONS_REQUEST'
export const ADMIN_NOTIFICATIONS_SUCCESS = 'ADMIN_NOTIFICATIONS_SUCCESS'
export const ADMIN_NOTIFICATIONS_FAILURE = 'ADMIN_NOTIFICATIONS_FAILURE'

export const MARK_ADMIN_NOTIFICATION_READ_REQUEST =
  'MARK_ADMIN_NOTIFICATION_READ_REQUEST'
export const MARK_ADMIN_NOTIFICATION_READ_SUCCESS =
  'MARK_ADMIN_NOTIFICATION_READ_SUCCESS'
export const MARK_ADMIN_NOTIFICATION_READ_FAILURE =
  'MARK_ADMIN_NOTIFICATION_READ_FAILURE'

export const MARK_ALL_ADMIN_NOTIFICATIONS_READ_REQUEST =
  'MARK_ALL_ADMIN_NOTIFICATIONS_READ_REQUEST'
export const MARK_ALL_ADMIN_NOTIFICATIONS_READ_SUCCESS =
  'MARK_ALL_ADMIN_NOTIFICATIONS_READ_SUCCESS'
export const MARK_ALL_ADMIN_NOTIFICATIONS_READ_FAILURE =
  'MARK_ALL_ADMIN_NOTIFICATIONS_READ_FAILURE'

export const DISMISS_ADMIN_NOTIFICATION_TOAST =
  'DISMISS_ADMIN_NOTIFICATION_TOAST'

export function fetchAdminNotifications(params = {}) {
  let url = 'notifications/'
  const qs = new URLSearchParams()
  if (params.unread) qs.append('unread', params.unread)
  if (params.category) qs.append('category', params.category)
  const qsStr = qs.toString()
  if (qsStr) url += `?${qsStr}`

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: url,
      authenticated: true,
      msg: 'fetchAdminNotifications',
      types: [
        ADMIN_NOTIFICATIONS_REQUEST,
        ADMIN_NOTIFICATIONS_SUCCESS,
        ADMIN_NOTIFICATIONS_FAILURE
      ]
    }
  }
}

export function markAdminNotificationRead(recipientId) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `notifications/${recipientId}/read/`,
      authenticated: true,
      msg: 'markAdminNotificationRead',
      types: [
        MARK_ADMIN_NOTIFICATION_READ_REQUEST,
        MARK_ADMIN_NOTIFICATION_READ_SUCCESS,
        MARK_ADMIN_NOTIFICATION_READ_FAILURE
      ]
    }
  }
}

export function markAllAdminNotificationsRead() {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'notifications/read-all/',
      authenticated: true,
      msg: 'markAllAdminNotificationsRead',
      types: [
        MARK_ALL_ADMIN_NOTIFICATIONS_READ_REQUEST,
        MARK_ALL_ADMIN_NOTIFICATIONS_READ_SUCCESS,
        MARK_ALL_ADMIN_NOTIFICATIONS_READ_FAILURE
      ]
    }
  }
}

export function dismissNotificationToast() {
  return {
    type: DISMISS_ADMIN_NOTIFICATION_TOAST
  }
}
